module.exports = __webpack_public_path__ + "media/images/icons/people-group-icon-498075e886d069fcf1c723714a8b6b4b.svg";